import React from "react";
import { FormattedMessage } from "react-intl";

export const bannerData = [
  {
    title: (
      <FormattedMessage
        id="signup-banner-card2-title"
        defaultMessage="Advertiser"
      />
    ),
    color: "var(--main-color)",
    text: (
      <FormattedMessage
        id="signup-banner-card2-text"
        defaultMessage="I have a brand or direct offer and i want to promote it with AdGate."
      />
    ),
    styles: "styled1",
    className: "green",
    to: "/signup/advertiser",
  },

  {
    title: (
      <FormattedMessage
        id="signup-banner-card1-title"
        defaultMessage="Publisher"
      />
    ),
    color: "var(--second-color)",
    text: (
      <FormattedMessage
        id="signup-banner-card1-text"
        defaultMessage="I have website or other traffic that I want to monetize with AdGate."
      />
    ),
    styles: "styled2",
    className: "orange",
    to: "/signup/publisher",
  },
];
